import Router from "./routes";
import ThemeConfig from "./theme";
import ScrollToTop from "./components/ScrollToTop";
import { ThemeModeProvider } from "./contexts/theme-mode";
import { Modalprovider } from "./contexts/modal";

function App() {
    return (
        <ThemeModeProvider>
            <ThemeConfig>
                <Modalprovider>
                    <ScrollToTop/>
                    <Router/>
                </Modalprovider>
            </ThemeConfig>
        </ThemeModeProvider>
    );
}

export default App;
